import { Link } from '@ecomm/framework'
import type { ReactNode } from 'react'

type RightSideLinkProps = {
  readonly children: ReactNode
  readonly to: string
  readonly onClick: () => void
  readonly className: string
}
export function RightSideLink({
  children,
  onClick,
  to,
  className
}: RightSideLinkProps) {
  return (
    <Link
      className={className}
      data-testid="rightside-link"
      onClick={onClick}
      to={to}
    >
      {children}
    </Link>
  )
}
